import { useState, useEffect } from 'react';

export function useSelect(
    curr: string | number,
    deps: any[] = []
): [
        string | number,
        (value: string | number) => void,
        (value: string | number) => void
    ] {
    const [current, setCurrent] = useState<string | number>(curr);

    useEffect(() => {
        setCurrent(curr);
    }, deps);

    const setCurrentFn = (value: any): void => {
        setCurrent(value);
    };

    return [current, setCurrentFn, setCurrent];
}

export default useSelect;
